module.exports = __webpack_public_path__ + "img/anzgog.68d391d.png";